// Types
import type { I_It4Login, I_It4Login_Return } from "./it4Login.types.js";

import axios from "../configRequest.js";
import { I_AXIOS } from "../configRequest.model.js";

export const it4Login: I_It4Login = async (data) => {
    const loginData = await axios.post<I_It4Login_Return["data"]>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/um/oplc/login?authorizationToken=${data.authorizationToken}&channel=${data.channel}`,
        {
            headers: {
                Accept: "application/json;charset=UTF-8",
            },
        },
    );
    return loginData.data;
};

export default it4Login;
